module.exports = "/_next/static/images/video_id_7111141381036330286-44485f4c56e1788dfc89c2f8c4abb1fb.jpg";